import React, { FC, useEffect, useState } from 'react';
import Modal from '../../../../screens/Products/Plural/Login/components/Modal';
import { getSelectedProduct } from '../../../../lib/helper';
import imgURL from '../../../../lib/imgURL';
import Slide from '../Slide';
import { citi_slides, slides, pacb_slides } from './constants';
import Props from './typing';
import './styles.scss';
import { isCitiTheme } from '../../../../lib/analyticsUtil';

const SlideModal: FC<Props> = (props): JSX.Element => {
  const isCiti = isCitiTheme();
  const [filterSlidesByProduct, setFilterSlidesByProduct] = useState<
    {
      product: string;
      img: string;
      title: string;
      description: {
        lines: string[];
        link?: string;
      };
    }[]
  >([]);

  useEffect(() => {
    if (props?.isPACBTour) {
      setFilterSlidesByProduct(pacb_slides);
    } else {
      const selectedProduct = getSelectedProduct();
      const filteredSlides = isCiti ? citi_slides?.filter(
        (slide) =>
          slide?.product === 'COMMON' || slide?.product === selectedProduct
      ) : slides?.filter(
        (slide) =>
          slide?.product === 'COMMON' || slide?.product === selectedProduct
      );
      setFilterSlidesByProduct(filteredSlides);
    }
  }, []);

  return (
    <Modal
      className={'tour-slides-modal'}
      backButtonEnable={false}
      // onBackdropClick={() => props?.closeModal()}
    >
      <div className='modal-content-header'>
        <h2 className='modal-heading'></h2>
        <img
          className='cursor-pointer'
          src={imgURL['cross-circle']}
          alt='Close'
          onClick={() => props?.closeModal()}
        />
      </div>
      <div className='modal-content-body'>
        <Slide
          slide={filterSlidesByProduct[props?.currentStep]}
          islastSlide={filterSlidesByProduct?.length === props?.currentStep + 1}
          currentSlideNo={props?.currentStep + 1}
          lastSlideNo={filterSlidesByProduct?.length}
          currentStep={props?.currentStep}
          setCurrentStep={(value) => props?.setCurrentStep(value)}
          closeModal={() => props?.closeModal()}
        />
      </div>
    </Modal>
  );
};

export default SlideModal;
